



function radioButton() {


    if (jQuery(".radio-t").length) {

        var mainSelector          = ".radio-t";
        var inputSelector         = ".radio-t .inputs-t";
        var activeClass           = "selected-t";
        var radioHandlerSelector  = ".radiohndlr-t";

        var radioDelete        = ".rdiobtn-tpl-m7 .radiobtnctn-m7>.radiohndlr-t .inputctn-t .radio-t";


        var radio_activer = function(ele){

            var radioLabel = $(ele).closest(radioHandlerSelector).find(mainSelector);
            $( radioLabel ).removeClass(activeClass);
            $(ele).closest(mainSelector).addClass(activeClass);
            $(radioDelete).removeClass(activeClass);
        }

        $(document).on('click', inputSelector , function(event) {

            var timer;
            var this_ele = this;
            timer = setTimeout(function () {
                radio_activer(this_ele);
            });
        });


        $(inputSelector).each(function(index, el) {
            if ( $(this).parents(mainSelector).hasClass(activeClass) ){
                $(this).prop('checked', true).trigger("change");
            }
        });
    }
};





export {radioButton}
